export const REACT_APP_REDIRECT_URI_MUNDI = process.env.REACT_APP_PUBLIC_URL
export const AUTH_APP_URL = process.env.REACT_APP_AUTH_URL
export const AUTH_APP_SESSION_URL = `${AUTH_APP_URL}/api/session`
export const AUTH_APP_LOGIN_URL = `${AUTH_APP_URL}/login`
export const AUTH_APP_LOGOUT_URL = `${AUTH_APP_URL}/api/logout`
export const LOGGED_STATE = 'loggedIn'
export const LOGIN_URL_WITH_REDIRECT = `${AUTH_APP_LOGIN_URL}?redirectUri=${window.location.origin}`
export const LOGOUT_URL_WITH_REDIRECT = `${AUTH_APP_LOGOUT_URL}?redirectUri=${window.location.origin}`
